import { useEffect, FC } from 'react';
import { TransactionId } from 'vopay';
import useZelle from '@/hooks/useApi/useZelle';
import ZelleTransactionInfo from './ZelleTransactionInfo';
import { useDataFetchIndicator } from '@/hooks';
import { useAlertDialog } from '@/providers/AlertDialog.provider';

const ZelleTransactionContainer: FC<TransactionId & { fullName: string; jwt: string; ELinxRequestID?: string }> = ({
  TransactionID,
  fullName,
  jwt,
  ELinxRequestID = '',
}) => {
  const [, setLoading] = useDataFetchIndicator();
  const alertDialog = useAlertDialog();

  const { fetchZelleWithdrawTransaction, transaction } = useZelle({ bearer: jwt });

  useEffect(() => {
    const fetchTransaction = async () => {
      try {
        setLoading(true);
        await fetchZelleWithdrawTransaction(TransactionID);
      } catch (error) {
        alertDialog.error('Error', error instanceof Error ? error.message : 'An unexpected error occurred.');
      } finally {
        setLoading(false);
      }
    };
    fetchTransaction();
  }, [TransactionID]);

  return (
    <div>
      {transaction && (
        <ZelleTransactionInfo transaction={transaction} fullName={fullName} jwt={jwt} ELinxRequestID={ELinxRequestID} />
      )}
    </div>
  );
};

export default ZelleTransactionContainer;
